import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { formatMonth } from "@/lib/format";
import { cn } from "@/lib/utils";

interface MonthSelectProps {
  /** "2026-11". */
  value: string;
  onChange: (month: string) => void;
  /** The months to offer, in order (`monthOptions`). */
  months: readonly string[];
  /** The control's name for screen readers: "Maand". */
  label: string;
  id?: string;
  disabled?: boolean;
  className?: string;
  /** Takes the focus when it shows, as the first control of a form opened in place. */
  autoFocus?: boolean;
}

/** A choice of month in the dashboard's theme (never a native select): "november 2026". */
export function MonthSelect({
  value,
  onChange,
  months,
  label,
  id,
  disabled,
  className,
  autoFocus,
}: MonthSelectProps) {
  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger
        id={id}
        size="sm"
        aria-label={label}
        autoFocus={autoFocus}
        className={cn("w-48", className)}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="max-h-72">
        {months.map((month) => (
          <SelectItem key={month} value={month}>
            {formatMonth(month)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
